import "./FAQSection.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";

const faqData = [
  {
    id: "q1",
    question: "자비 출판을 시작하기 전에 무엇을 준비하면 좋나요?",
    answer:
      "자비 출판을 시작하기 전에는 원고, 출간 목적, 독자층, 제작 방향을 미리 정리해두는 것이 좋습니다. \n 전체 목차와 원고 구성이 정리되어 있으면 상담과 제작 진행이 수월하며, 어떤 독자를 대상으로 어떤 메시지를 전할 책인지가 명확할수록 편집·디자인 방향을 잡기 쉽습니다. 또한 판형, 제본 방식, 컬러 여부, 예산 범위, 유통 방식, 홍보 계획 등을 미리 생각해두면 제작 범위를 정하는 데 도움이 됩니다. 저자 소개, 책 소개, 주요 키워드, 추천 독자와 같은 도서 소개 자료도 온라인 서점 등록과 홍보에 필요합니다.",
  },
  {
    id: "q2",
    question: "자비 출판 진행 시 비용은 어떻게 정해지나요?",
    answer:
      "자비 출판 비용은 원고 분량, 편집 난이도, 판형, 디자인 범위, 종이책 제작 방식, 인쇄 부수, 마케팅 지원 여부 등에 따라 달라집니다. \n 정확한 비용은 원고 검토와 제작 사양 확정 후 안내드립니다.",
  },
  {
    id: "q3",
    question: "자비 출판시 출간까지 전체 기간은 얼마나 걸리나요?",
    answer:
      "출간까지 걸리는 기간은 원고 분량, 편집 범위, 디자인 난이도, 전자책·종이책 제작 여부, 인쇄 방식 등에 따라 달라집니다. \n 일반적으로 편집 가능한 원고를 제출한 후 출간까지 약 2~3개월 정도 소요되며, 저자 피드백 속도나 제작 사양에 따라 일정은 달라질 수 있습니다. 정확한 일정은 원고 검토 후 제작 범위와 함께 안내드립니다.",
  },
  {
    id: "q4",
    question: "자비 출판시 판매 수익은 어떻게 정산되나요?",
    answer:
      "자비 출판 도서의 판매 수익은 계약에서 정한 기준에 따라 정산됩니다. \n 종이책은 판매된 부수에 대해 정가의 50%, 전자책은 판매 순수익의 60%를 저자 인세로 지급합니다. \n정산 주기와 세부 기준은 계약 시 안내드립니다.",
  },
  {
    id: "q5",
    question: "자비 출판은 기획 출판 · 반기획 출판과 어떻게 다른가요?",
    answer:
      "자비 출판은 저자가 출간 비용을 부담하고, 출판사는 편집 · 디자인 · 제작 · 유통 · 정산 등 출간 과정을 지원하는 방식입니다. \n 반기획 출판은 저자와 출판사가 출간 비용, 제작 역할, 유통·마케팅 범위 등을 협의해 분담하는 방식입니다. \n기획 출판은 출판사가 시장성과 원고의 가능성을 검토해 출간을 결정하고, 출간 비용을 부담하며 기획부터 편집·제작·유통·마케팅까지 전 과정을 주도하는 방식입니다.",
  },
  {
    id: "q6",
    question: "자비 출판 도서는 어디에서 판매되나요?",
    answer:
      "주요 온라인 서점과 전자책 플랫폼에 등록해 판매할 수 있습니다.\n 대표적인 유통 채널로는 교보문고, YES24, 알라딘, 리디북스 등이 있으며, 도서의 형식과 제작 방식에 따라 중소형 서점 및 기타 판매 채널로도 유통을 검토할 수 있습니다.",
  },
];

const FAQItem = ({
  id,
  question,
  answer,
  isOpen,
  onToggle,
  loggedIn,
  loginClickHandle,
}) => {
  return (
    <div className={`faq-card ${isOpen ? "open" : ""}`}>
      <div
        className="faq-card-question-header"
        onClick={() => onToggle(id)}
        role="button"
        tabIndex="0"
      >
        <h3>{question}</h3>
        <img
          src="./images/arrow-down.png"
          alt="Toggle dropdown"
          className="faq-card-arrow"
        />
      </div>
      <div
        id={`faq-answer-${id}`}
        className="faq-card-answer"
        aria-hidden={!isOpen}
      >
        {/* {loggedIn === true ? (
          <p>{answer}</p>
        ) : (
          <div className="faq-login">
            <button
              className="faq-login-btn"
              onClick={(e) => {
                e.stopPropagation();
                loginClickHandle();
              }}
            >
              로그인 해주세요
            </button>
          </div>
        )} */}
        <p>{answer}</p>
      </div>
    </div>
  );
};

const FAQSection = () => {
  // const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const [openFAQId, setOpenFAQId] = useState(null);
  const location = useLocation();

  const qaLinks = [
    { label: "자비 출판 FAQ", path: "/qa-self" },
    { label: "반기획 출판 FAQ", path: "/qa-semi-planned" },
    { label: "기획 출판 FAQ", path: "/qa-planned" },
    { label: "아마존 킨들 출판 대행 FAQ", path: "/qa-amazon" },
  ];

  const handleToggleFAQ = (id) => {
    setOpenFAQId((prevId) => (prevId === id ? null : id));
  };

  const handleGoToClick = (path) => {
    // if (!isLoggedIn) {
    //   const confirmed = window.confirm("견적서 페이지는 로그인이 필요합니다.\n\n로그인 하시겠습니까?");
    //   if (confirmed) {
    //     navigate("/login");
    //   }
    //   return;
    // }

    navigate(path)
  }

  return (
    <section id="faq-section" className="faq-section-container">
      <div className="faq-section">        
        <div id="faq-section-header" class="faq-section-header">
          <h2>자주 묻는 질문</h2>
          <div className="goto-questions-wrapper">
            {qaLinks.map(({ label, path }) => (
              <div className="goto-questions" key={path}>
                <button
                  aria-label="View all questions"
                  onClick={() => {
                    const scrollY = window.scrollY;
                    sessionStorage.setItem("scrollToY", scrollY);
                    // isLoggedIn ? navigate(path) : navigate("/login");
                    handleGoToClick(path);
                  }}
                >
                  <p>{label}</p>
                  <img src="/images/next.png" alt="Next arrow" />
                </button>
              </div>
            ))}
          </div>
        </div>
        <div className="faq-cards-container">
          {faqData.map((faq) => (
            <FAQItem
              key={faq.id}
              {...faq}
              isOpen={openFAQId === faq.id}
              onToggle={handleToggleFAQ}
              // loggedIn={isLoggedIn}
              // loginClickHandle={() => navigate("/login")}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
